// extracted by mini-css-extract-plugin
export default {"body":"ModalRisks_body__iKccY","list":"ModalRisks_list__J0IeC"};